import Link from "next/link";
import React from "react";

import styles from "./Footer.module.scss";
import Image from "next/image";

const Footer = () => {
  return (
    <section className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.col1}>
          <ul className={styles.listItem}>

            <li className={styles.item}>
              <Link href={"/bloveToken"}>B-Love Token</Link>
            </li>
            <li className={styles.item}>
              <Link href={"/tokenRewards"}>Token Rewards</Link>
            </li>
            <li className={styles.item}>
              <Link href={"/terms"}>Terms and Conditions</Link>
            </li>
            <li className={styles.item}>
              <Link href={"/account-deletion"}>Account Deletion</Link>
            </li>
          </ul>
        </div>

        <div className={styles.line} />

        <div className={styles.download}>
          <Image
            src="/assets/Image/logoFooter.png"
            width={159}
            height={58}
            alt="footer"
          />

          <Link target="_blank" href={"https://play.google.com/store/apps/details?id=biz.innovationfactory.bnetwork&hl=en_US"} className={styles.btn}>Downlaod Now</Link>
        </div>

        <div className={styles.line} />

        <div className={styles.socailMedia}>
          <h4 className={styles.title}>Follow Us</h4>
          <div className={styles.icons}>
            <Link href={"https://www.facebook.com/Bficblovenetwork"} target="_blank">
              {" "}
              <Image
                src="/assets/svg/facebookIcon.png"
                width={25}
                height={25}
                alt="icons"
              />{" "}
            </Link>
            <Link href={"https://t.me/+lZfudFWL1kI4ZmZk"} target="_blank">
              <Image
                src="/assets/svg/telegramicon.png"
                width={25}
                height={25}
                alt="icons"
              />{" "}
            </Link>
            <Link href={"https://www.instagram.com/bficblovenetwork/"} target="_blank">
              {" "}
              <Image
                src="/assets/svg/InstagramIcon.png"
                width={25}
                height={25}
                alt="icons"
              />{" "}
            </Link>
            <Link href={"https://twitter.com/BFICBLove"} target="_blank">
              <Image
                src="/assets/svg/twiter.png"
                width={25}
                height={25}
                alt="icons"
              />{" "}
            </Link>
          </div>
        </div>
      </div>
      <div className="bg-clr-gray-dark h-[1px] w-full opacity-[0.2]" />
      <div className={styles.copyRightWrapper}>
        <h2 className={styles.copyRight}>
          © Copyright 2023 All rights are reserved by Innovation Factory
        </h2>
      </div>
    </section>
  );
};

export default Footer;
